// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-entity-test',
    // #endregion
    // #region Props
    props: {
        window: Object
    },
    // #endregion
    // #region Data
    data: () => ({
        entity: {},
        navigation: {},
        component: null,
        args: {}
    }),
    // #endregion
    // #region Created
    created() {
        if (this.window) {
            this.entity = this.window.entity;
            this.navigation = this.window.navigation;
            this.args = this.window.args;
            this.component = this.window.component;
        }
    },
    // #endregion
    // #region Watch
    watch: {
        "window"(value) {
            if (this.window) {
                this.entity = this.window.entity;
                this.navigation = this.window.navigation;
                this.args = this.window.args;
                this.component = this.window.component;
            }
        },
    },
    // #endregion
    // #region Run
    methods: {
        update() {
            if (this.window) {
                this.window.entity = this.entity;
                this.window.navigation = this.navigation;
                this.window.args = this.args;
                this.window.component = this.component;
            }
            ;
            //Update
            if (this.window) {
                this.$router.updateWindow(this.window);
            }
        },
        close() {
            if (this.window) {
                this.$router.closeWindow(this.window);
            }
        },
    }
    // #endregion
});
// #endregion
